import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

export default class StoreBuilder {
  constructor(options = {}) {
    const { initialState, reducers, middlewares } = options;
    Object.assign(this, options);

    // defaults
    if (!middlewares) {
      this.middlewares = [thunk];
    }
    if (!reducers) {
      this.reducers = (state = {}) => state;
    }

    this.createRootReducer(reducers);
    this.createStore(initialState, middlewares);
  }

  createRootReducer(reducers = this.reducers) {
    if (typeof reducers === 'function') {
      this.rootReducer = this.reducers;
    } else {
      this.rootReducer = combineReducers(reducers);
    }
  }

  createStore(
    initialState = this.initialState,
    middlewares = this.middlewares,
  ) {
    // runs once
    this.store =
      this.store ||
      createStore(
        this.rootReducer,
        initialState,
        composeWithDevTools(applyMiddleware(...middlewares)),
      );
  }

  mergeNewReducers(newReducers) {
    if (typeof newReducers === 'function') {
      throw new Error('Cannot merge pre-combined new Reducer');
    }

    if (typeof this.reducers === 'function') {
      this.reducers = newReducers;
    } else {
      this.reducers = Object.assign({}, this.reducers, newReducers);
    }

    this.createRootReducer();

    this.store.replaceReducer(this.rootReducer);
  }
}
